<template>
  <div class="basic-data-modal">
    <v-dialog
      v-model="isVisible"
      max-width="566"
      persistent
      scrollable
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          class="basic-data-modal__title headline"
          primary-title
        >
          BASIC INFORMATIONS
        </v-card-title>

        <v-card-text>
          <v-form
            v-if="developerData.personal_data"
            ref="developerDataForm" v-model="isFormValid" @submit.prevent="submitForm">
            <v-row class="basic-data-modal__row">
              <v-col class="basic-data-modal__col">
                <v-select
                  v-model="developerData.personal_data.status"
                  class="form-field"
                  :items="featuresData.status"
                  :rules="[rules.required]"
                  dense
                  label="Status*"
                  placeholder="Choose your status"
                />
              </v-col>
              <v-col class="basic-data-modal__col">
                <v-text-field
                  v-model="developerData.personal_data.email"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="Email Address*"
                  placeholder="Enter your e-mail address"
                />
              </v-col>
            </v-row>

            <v-row class="basic-data-modal__row">
              <v-col class="basic-data-modal__col">
                <v-text-field
                  v-model="developerData.personal_data.first_name"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="First name*"
                  placeholder="Type name"
                />
              </v-col>
              <v-col class="basic-data-modal__col">
                <v-text-field
                  v-model="developerData.personal_data.last_name"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="Last name*"
                  placeholder="Type name"
                />
              </v-col>
            </v-row>

            <v-row class="basic-data-modal__row">
              <v-col class="basic-data-modal__col">
                <v-text-field
                  v-model="developerData.personal_data.city"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="City*"
                  placeholder="Type your city"
                />
              </v-col>
              <v-col class="basic-data-modal__col">
                <v-autocomplete
                  v-model="developerData.personal_data.nationality"
                  class="form-field"
                  :items="nationalities"
                  item-value="nationality"
                  item-text="nationality"
                  :rules="[rules.required]"
                  dense
                  label="Nationality*"
                  placeholder="Choose nationality"
                />
              </v-col>
            </v-row>

            <v-row class="basic-data-modal__row">
              <v-col class="basic-data-modal__col">
                <v-autocomplete
                  v-model="developerData.roles"
                  class="form-field"
                  item-color="blue"
                  :items="featuresData.roles"
                  :rules="[rules.required]"
                  dense
                  multiple
                  label="Primary Roles*"
                  placeholder="Choose skills"
                  :search-input.sync="rolesSearchInput"
                  @change="rolesSearchInput=''"
                >
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="basic-data-modal__row">
              <v-col class="basic-data-modal__col">
                <v-autocomplete
                  v-model="developerData.top_skills"
                  class="form-field"
                  item-color="blue"
                  :items="featuresData.top_skills"
                  :rules="[rules.required]"
                  dense
                  multiple
                  label="Top skills*"
                  placeholder="Choose skills"
                  :search-input.sync="skillsSearchInput"
                  @change="skillsSearchInput=''"
                >
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="basic-data-modal__row">
              <v-col class="basic-data-modal__col">
                <v-select
                  v-model="developerData.language_name"
                  class="form-field"
                  :items="featuresData.language_name"
                  :rules="[rules.required]"
                  dense
                  label="Language*"
                  placeholder="Choose language"
                />
              </v-col>
              <v-col class="basic-data-modal__col">
                <v-select
                  v-model="developerData.language_level"
                  class="form-field"
                  :items="featuresData.language_level"
                  :rules="[rules.required]"
                  dense
                  label="Level*"
                  placeholder="Choose level"
                />
              </v-col>
            </v-row>

            <v-row class="basic-data-modal__row">
              <v-col class="basic-data-modal__col">
                <v-select
                  v-model="developerData.personal_data.level"
                  class="form-field"
                  :items="featuresData.level"
                  dense
                  :rules="[rules.required]"
                  label="Level*"
                  placeholder="Select your level"
                />
              </v-col>
              <v-col class="basic-data-modal__col">
                <v-text-field
                  v-model="developerData.personal_data.experience_in_years"
                  class="form-field"
                  dense
                  :rules="[rules.required, rules.negative]"
                  label="Experience*"
                  placeholder="Type your experience in years"
                  type="number"
                  min="0"
                />
              </v-col>
            </v-row>

            <v-row class="basic-data-modal__row">
              <v-col class="basic-data-modal__col">
                <v-text-field
                  v-model="developerData.finance.rate"
                  class="form-field"
                  :rules="[rules.required, rules.positive]"
                  dense
                  label="Rate"
                  placeholder="Type hourly rate..."
                  suffix="/ h"
                  type="number"
                />
              </v-col>
              <v-col class="basic-data-modal__col">
                <v-select
                  value="PLN"
                  class="form-field"
                  :items="featuresData.currency"
                  dense
                  flat
                  disabled
                  label="Currency"
                  placeholder="Choose"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="basic-data-modal__actions">
          <v-row class="basic-data-modal__row">
            <v-col class="basic-data-modal__col py-0">
              <v-btn
                class="basic-data-modal__btn basic-data-modal__btn--back"
                color="button"
                large
                depressed
                @click="goBack"
              >
                <v-icon small class="mr-3">mdi-arrow-left</v-icon> Back
              </v-btn>
            </v-col>
            <v-col class="basic-data-modal__col py-0">
              <v-btn
                class="basic-data-modal__btn basic-data-modal__btn--submit white--text"
                color="blue"
                large
                depressed
                :loading="processing"
                @click="submit"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';
import nationalities from '@/helpers/nationalities';

const rules = validationRules;

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },

    featuresData: {
      type: Object,
      required: true,
    },

    processing: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      rules,
      isFormValid: true,
      nationalities,
      developerData: {
        personal_data: {
          first_name: '',
          last_name: '',
          email: '',
          city: '',
          nationality: '',
          level: '',
          experience_in_years: '',
          status: '',
          phone_number: '',
          birthdate: '',
          linkedin_link: '',
          git_link: '',
          skype_link: '',
          software_house: {
            name: '',
            pm_first_name: '',
            pm_last_name: '',
            pm_email: '',
            pm_phone_number: '',
          },
        },
        finance: {
          rate: '',
          currency: 'PLN',
          working_hours: [],
          contract_types: [],
        },
        languages: [],
        roles: [],
        top_skills: [],
      },
      rolesSearchInput: '',
      skillsSearchInput: '',
    };
  },

  computed: {
    ...mapState('hrDeveloper', [
      'developer',
    ]),

    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    isVisible() {
      if (this.isVisible) this.developerData = JSON.parse(JSON.stringify(this.developer));
    },
  },

  methods: {
    ...mapActions('hrDeveloper', [
      'updateDeveloper',
    ]),

    closeModal() {
      this.$emit('input', false);
    },

    goBack() {
      this.$emit('input', false);
      this.$router.push({ name: 'hr-developers' });
    },

    submit() {
      this.$refs.developerDataForm.validate();

      if (this.isFormValid) {
        this.developerData.finance.currency = 'PLN';

        this.updateDeveloper(this.developerData)
          .then(() => {
            this.closeModal();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-data-modal {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 0 24px 16px 24px;
    justify-content: flex-end;
  }

  &__row {
    margin-right: -8px;
    margin-left: -8px;
  }
  &__col {
    padding: 0 6px 8px;
  }

  &__btn {
    width: 100%;

    &--back {
      color: #434550 !important;
    }
  }
}
</style>
